import dayjs from "dayjs";
export const DEFAULT_STRIPE_EXPIRATION_MONTHS = 24;

export const calculateDefaultStripeExpirationDate = (
  monthsToAdd: number = DEFAULT_STRIPE_EXPIRATION_MONTHS,
) => {
  return dayjs().utc().add(monthsToAdd, "month").endOf("month");
};
